export enum UserAvailabilityStatus {
    Offline = 0,
    Online = 1,
    Away = 2,
    Busy = 3,
}